import * as React from 'react';

const HistoryChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path fill="#fff" d="M11.5 12.6V8.2h.5v4.2l3.3 2.2-.2.4z" />
        <path d="M12.5 7.7H11v5.2l4.3 2.8.7-1.3-3.5-2.3V7.7z" />
        <g>
            <path d="M4 5v3.7V5m4 3.7H4.3 8M12 3C9.2 3 6.7 4.3 5 6.3V4H3v5.8h6v-2H6.2c1.4-2 3.6-3 5.8-3 3.7 0 7.2 3 7.2 7.2s-3.5 7.2-7.2 7.2c-1.5 0-3.1-.6-4.3-1.4l-1.1 1.4C8.1 20.3 10 21 12 21c5 0 9-4 9-9s-4-9-9-9z" />
        </g>
    </svg>
);

HistoryChunkySvg.displayName = 'HistoryChunkySvg';
export default HistoryChunkySvg;
